import { createStore, applyMiddleware } from "redux";
import { composeWithDevToolsDevelopmentOnly } from "@redux-devtools/extension";
import rootReducer from "../reducers";
import thunkMiddleware from "redux-thunk";

const composeEnhancers = composeWithDevToolsDevelopmentOnly({
  // Specify name here, actionsDenylist, actionsCreators and other options if needed
});

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

store.subscribe(() => {
  //ForTesting
  // console.log('state update');
  //  console.log(store.getState());
});
